import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Dropdown } from 'primeng/dropdown';
import { AccelaControl } from 'src/app/modules/shared/model/accelaControl.model';
import { AdminSelectionEvent } from '../../model/adminSelectionEvent';

@Component({
  selector: 'accela-dropdown-input',
  templateUrl: './accela-dropdown-input.component.html',
  styleUrls: ['./accela-dropdown-input.component.css'],
})
export class AccelaDropdownInputComponent implements OnInit, AfterViewInit {
  @Input() controlRef: AbstractControl;
  @Input() parentFormRef: UntypedFormGroup;
  @Input() adminMode = false;
  @Input() readonlyMode = false;
  @Input() requiredValidationMsg: string;
  
  @Output() selectionEvent = new EventEmitter<AdminSelectionEvent>();
  @Output() focusChange = new EventEmitter<AbstractControl>();

  @ViewChild('accelaControlDiv') accelaControlDiv: ElementRef;
  @ViewChild('dropdownWrapper') accelaDropdown: Dropdown;

  label: string;

  controlData: AccelaControl;

  Value: string;

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.controlData = this.controlRef.controlData;
    this.label = this.controlData.label;
  }

  ngAfterViewInit(): void {
    if(this.adminMode){
      this.controlData.readOnly = true;
      this.accelaControlDiv.nativeElement.addEventListener('click', (e: MouseEvent) =>{
        this.adminSelect(e);
      });
    }

    this.accelaDropdown.labelId = this.getLabelElementId();
    const dropdownIconRef = this.accelaControlDiv.nativeElement.querySelector('div[role=\'button\']');
    if(dropdownIconRef){
      this.renderer.setAttribute(dropdownIconRef,'aria-label', 'Select '+this.controlData.label);
    }

    const inputControlRef = this.accelaControlDiv.nativeElement.querySelector('#'+this.controlData.name+'Input');
    if(inputControlRef){
      this.renderer.removeAttribute(inputControlRef,'aria-activedescendant');
      this.renderer.setAttribute(inputControlRef,'aria-label', this.controlData.label);
    }

    const dropdownLabelRef = this.accelaControlDiv.nativeElement.querySelectorAll('#'+this.getLabelElementId());
    if(dropdownLabelRef){
       dropdownLabelRef.forEach((element,idx) => {
        this.renderer.setAttribute(element,'id', this.controlData.name+'SelectedItem_'+idx);
         });
    }
  }

  getDivElementId(){
    return 'div_'+this.controlData.name;
  }

  getLabelElementId(){
    return this.controlData.name+'InputLabel';
  }

  getRequiredFieldValidationMsg(){
    return this.requiredValidationMsg + ' '+this.label;
  }

  adminSelect(e: Event): void {
    const ev = e as AdminSelectionEvent;
    ev.controlData = this.controlData;
    ev.elementRef = e.target as Element;
    this.selectionEvent.emit(ev);
   }

  emitBlurEvent(event: any) {
    if (this.controlRef != null && this.controlRef.value != null)
      this.controlRef.setValue(this.controlRef.value.trim());

    this.focusChange.emit(this.controlRef);
  }
}
